import { createSelector } from 'reselect';
import { getDealValidationKey } from '../utils/dealValidation';

//@ts-expect-error untyped
const dealValidation = state => state.dealValidation;
export const getDealPropertyValidation = (dealId, propertyName) => createSelector([dealValidation], validations => validations[getDealValidationKey(dealId, propertyName)]);
export const getAreAllPropertiesSaveable = createSelector([dealValidation], validations => Object.keys(validations).reduce((acc, key) => acc && validations[key].saveable, true));